/**
 * Compatibility layer for the deprecated keywordMap.json
 * 
 * This module provides the same data structure as the old JSON file
 * but sources data from the canonical tradeCategories.ts module.
 * 
 * IMPORTANT: This is a transitional module and should be considered deprecated.
 * New code should use tradeCategories.ts directly.
 */

import { TRADE_CATEGORIES } from '../tradeCategories';

// Build the flattened keyword map from TRADE_CATEGORIES
const buildKeywordMap = (): Record<string, string> => {
  const result: Record<string, string> = {
    // Add metadata to the object
    _deprecated: "This is a compatibility layer for the deprecated keywordMap.json. Please use tradeCategories.ts directly for new code."
  };
  
  // Process each trade category
  TRADE_CATEGORIES.forEach((category) => {
    // Add each keyword as a key mapping to the category ID
    category.keywords.forEach((keyword) => {
      // Only add keywords that are at least 3 characters (matching original behavior)
      if (keyword.length >= 3) {
        result[keyword] = category.id;
      }
    });
  });
  
  return result;
};

/**
 * Recreates the structure of the old keywordMap.json file
 * Each key is a keyword and the value is the trade category
 */
export const keywordMap = buildKeywordMap();

export default keywordMap;